// src/index.js
import React, { useContext } from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import { LanguageProvider, LanguageContext } from "./context/LanguageContext";

import { CacheProvider } from "@emotion/react";
import { ThemeProvider, CssBaseline } from "@mui/material";

import { cacheLtr, cacheRtl } from "./utils/rtlCache";
import { ThemeProviderApp, useAppTheme } from "./context/ThemeContext";

function RootInner() {
  const { lang } = useContext(LanguageContext);
  const isRtl = ["ar", "ur"].includes(lang);

  const cache = isRtl ? cacheRtl : cacheLtr;
  const { muiTheme } = useAppTheme();

  return (
    <CacheProvider value={cache}>
      <ThemeProvider theme={muiTheme}>
        <CssBaseline />
        <App />
      </ThemeProvider>
    </CacheProvider>
  );
}

function Root() {
  return (
    <ThemeProviderApp>
      <RootInner />
    </ThemeProviderApp>
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <LanguageProvider>
      <Root />
    </LanguageProvider>
  </React.StrictMode>
);
